import { AuthenticatedLayout } from "../../layouts";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { PayrollSetup } from "../../components/PayrollSetup";

export const PayrollSetupPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Payroll"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        // { text: "Payroll", navigateTo: "/taxes/remittance/cra" },
      ]}
      mainContents={<PayrollSetup />}
    />
  );
};
